<template>
  <div class="add-notice-view-container">
    <div class="page-content">
      <div class="page-title">{{ $t('addNoticeView.title') }}</div>
      <el-form ref="form" :model="addNoticeViewInfo" :rules="rules" label-width="120px">
        <el-form-item :label="$t('addNoticeView.communityLabel')" prop="communityIds">
          <el-select
            v-model="addNoticeViewInfo.communityIds"
            multiple
            filterable
            collapse-tags
            :placeholder="$t('addNoticeView.communityPlaceholder')"
            style="width:100%"
          >
            <el-option v-for="item in communitys" :key="item.communityId" :label="item.name" :value="item.communityId" />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('addNoticeView.titleLabel')" prop="title">
          <el-input v-model="addNoticeViewInfo.title" :placeholder="$t('addNoticeView.titlePlaceholder')" clearable />
        </el-form-item>

        <el-form-item :label="$t('addNoticeView.noticeTypeLabel')" prop="noticeTypeCd">
          <el-select v-model="addNoticeViewInfo.noticeTypeCd" :placeholder="$t('addNoticeView.noticeTypePlaceholder')" style="width:100%">
            <el-option :label="$t('addNoticeView.noticeTypeOption1')" value="1000" />
            <el-option :label="$t('addNoticeView.noticeTypeOption2')" value="1001" />
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('addNoticeView.contentLabel')" prop="context">
          <div class="editor-wrapper">
            <rich-text-editor ref="richTextEditor" v-model="addNoticeViewInfo.context" :placeholder="$t('addNoticeView.contentPlaceholder')" />
          </div>
        </el-form-item>

        <div class="button-group">
          <el-button class="cancel-btn" @click="closeNoticeInfo">
            {{ $t('addNoticeView.cancel') }}
          </el-button>
          <el-button class="submit-btn" type="primary" @click="saveNoticeInfo">
            {{ $t('addNoticeView.submit') }}
          </el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { saveNotice } from '@/api/oa/addNoticeViewApi'
import { getEffectiveCommunityId, getMyEnteredCommunitys } from '@/api/community/communityApi'
import RichTextEditor from '@/components/editor/RichTextEditor'

export default {
  name: 'AddNoticeViewList',
  components: {
    RichTextEditor
  },
  data() {
    return {
      addNoticeViewInfo: {
        title: '',
        noticeTypeCd: '',
        context: '',
        startTime: '',
        endTime: '',
        objType: '',
        objId: '',
        floorId: '',
        unitId: '',
        roomId: '',
        state: '3000',
        isAll: 'N',
        communityId: '',
        communityIds: []
      },
      communitys: [],
      rules: {
        communityIds: [
          { type: 'array', required: true, message: this.$t('addNoticeView.validate.community'), trigger: 'change' }
        ],
        title: [
          { required: true, message: this.$t('addNoticeView.validate.title'), trigger: 'blur' },
          { max: 200, message: this.$t('addNoticeView.validate.titleMaxLength'), trigger: 'blur' }
        ],
        noticeTypeCd: [
          { required: true, message: this.$t('addNoticeView.validate.noticeType'), trigger: 'change' }
        ],
        context: [
          { required: true, message: this.$t('addNoticeView.validate.content'), trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    const communityId = getEffectiveCommunityId()
    this.addNoticeViewInfo.communityId = communityId
    this.addNoticeViewInfo.communityIds = communityId ? [communityId] : []
    this.loadCommunitys()
  },
  methods: {
    async loadCommunitys() {
      try {
        const res = await getMyEnteredCommunitys({ page: 1, row: 1000 })
        this.communitys = (res.communitys || []).filter(item => getEffectiveCommunityId(item.communityId))
      } catch (error) {
        this.$message.error(this.$t('addNoticeView.fetchCommunityError'))
      }
    },
    async saveNoticeInfo() {
      this.$refs.form.validate(async valid => {
        if (!valid) {
          return
        }
        try {
          for (const communityId of this.addNoticeViewInfo.communityIds) {
            const response = await saveNotice({
              ...this.addNoticeViewInfo,
              communityId
            })
            if (response.code !== 0) {
              this.$message.error(response.msg)
              return
            }
          }
          this.$message.success(this.$t('common.operationSuccess'))
          this.$router.go(-1)
        } catch (error) {
          this.$message.error(this.$t('addNoticeView.saveError'))
        }
      })
    },
    closeNoticeInfo() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.add-notice-view-container {
  padding: 20px;
  background-color: #EBF2FA;
  min-height: calc(100vh - 84px);
  font-family: 'PingFang SC', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', Arial, sans-serif;

  .page-content {
    background: #FFFFFF;
    border-radius: 12px;
    padding: 24px;
  }

  .page-title {
    color: #1D2129;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 20px;
  }

  ::v-deep .el-form-item__label {
    color: #1D2129;
    font-size: 14px;
    font-weight: 500;
  }

  ::v-deep .el-input__inner {
    border-radius: 10px;
    border: 1px solid #DCE6F5;
    height: 38px;
    line-height: 38px;
  }

  ::v-deep .el-select .el-input__inner {
    border-radius: 10px;
  }

  ::v-deep .el-input__inner:focus {
    border-color: #0E76FF;
  }

  .button-group {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
  }

  .editor-wrapper {
    height: 300px;
    margin-bottom: 20px;

    .ql-container {
      height: 250px;
    }
  }

  .cancel-btn {
    width: 98px;
    height: 38px;
    border-radius: 10px;
    border: 1px solid #0E76FF;
    color: #0E76FF;
    background: #FFFFFF;
  }

  .submit-btn {
    width: 98px;
    height: 38px;
    border-radius: 10px;
    border: none;
    background: #0E76FF;
  }
}
</style>
